import i18n from '../../i18n';
import type { ClientReview } from '../../api/reviews';

/**
 * A file is "uploaded" only once its record is READ BACK from the saved review
 * (docs/specs/review-document-integrity.md S2). On 2026-10-21 every one of Elvia's files answered 200 and
 * read "Uploaded" while the Balance Sheet's record had been overwritten by a concurrent write: the HTTP
 * status said the request succeeded, not that the record exists.
 */
export class DocumentNotSavedError extends Error {
  constructor(public readonly fileName: string) {
    super(i18n.t('upload.notSaved'));
    this.name = 'DocumentNotSavedError';
  }
}

/** Throws DocumentNotSavedError unless `recordId` is on the review as it was just re-read. */
export function assertRecordSaved(saved: Pick<ClientReview, 'financialDocuments' | 'aiReviewDocuments'>, recordId: string | undefined, fileName: string): void {
  const present = !!recordId && [...(saved.financialDocuments ?? []), ...(saved.aiReviewDocuments ?? [])].some((d) => d.id === recordId);
  if (!present) throw new DocumentNotSavedError(fileName);
}
